export default {
  API_ENDPOINT: "https://masteringserver.ngrok.io/api"
};
